'use strict';

// components
const venmoAccount = require('./components/venmoAccount');
const venmoCheckout = require('./components/venmoCheckout');
const venmoExpressCheckout = require('./components/venmoExpressCheckout');

/**
 * Inits Venmo functionality on the Account Page
 */
function initAccount() {
    venmoAccount.init();
}

/**
 * Inits Venmo functionality on the Billing Page
 */
async function initBillingCheckout() {
    await venmoCheckout.init();
}

/**
 * Inits Venmo functionality on the Express Checkout
 * @param {boolean} isMiniCart Whether is mini cart page flow or not
 */
async function initExpressCheckout(isMiniCart = false) {
    await venmoExpressCheckout.init(isMiniCart);
}

module.exports = {
    initAccount,
    initBillingCheckout,
    initExpressCheckout
};
